import { Form, Formik } from "formik";

import { putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import Title from "../../components/common/title/Title";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import { citiesListColumns } from "../../constant/tablesColumns/tablesColums";

export default function EditCities() {
  const location = useLocation();
  const navigate = useNavigate();

  const [cities, setCities] = useState([]);

  const addCity = async (values, { resetForm }) => {
    const isExist = cities.filter((item) => {
      return item.name == values.name;
    });
    if (!isExist?.length) {
      setCities((prev) => [...prev, { name: values.name, id: values.name }]);
      successMessage(`شهر ${values?.name} اضافه شد.`);
      resetForm()
    } else {
      warningMessage(`شهر ${values?.name} از قبل وجود دارد.`);
    }
  };

  const formHandler = async () => {
    const body = {
      cities: cities.map((item) => {
        return item.name;
      }),
    };
    const path = `admin/provinces/${location?.state?.id}/cities`;
    try {
      const response = await putApi({ path, body: JSON.stringify(body) });
      console.log(response);
      successMessage(`شهر های ${location?.state?.name} با موفقیت ویرایش شدند.`);
      navigate("/province-list");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  useEffect(() => {
    if (location?.state?.cities?.length) {
      setCities(
        location?.state?.cities.map((item) => {
          return {
            name: item,
            id: item,
          };
        })
      );
    }
  }, [location?.state]);

  const delteCity = (data) => {
    const newCities = cities.filter((item) => {
      return item.name != data.name;
    });
    setCities(newCities);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={`ویرایش شهرهای استان ${location?.state?.name}`} />
      <Formik
        enableReinitialize
        initialValues={{
          name: "",
        }}
        onSubmit={addCity}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input
                  name={"name"}
                  placeholder={"نام"}
                  label={"نام"}
                  type="text"
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="flex items-center gap-2 mt-6">
                  <Button text={"افزون"} color={"success"} />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>

      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <Title title={"لیست شهر ها"} />
        <Table columns={citiesListColumns} rows={cities} onDelete={delteCity} />
      </div>

      <div className="flex flex-col gap-y-2">
        <div className="flex items-center gap-2 mt-6">
          <Button
            text={"ویرایش شهر ها"}
            color={"success"}
            onClick={formHandler}
          />
        </div>
      </div>
    </div>
  );
}
